import { render, staticRenderFns } from "./CoozzyAppointmentText.vue?vue&type=template&id=12b1e5b3&scoped=true"
import script from "./CoozzyAppointmentText.vue?vue&type=script&lang=js"
export * from "./CoozzyAppointmentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1e5b3",
  null
  
)

export default component.exports